// extracted by mini-css-extract-plugin
export default {"TruncatedCrumbs__ellipsisSeparator":"TruncatedCrumbs-styles__TruncatedCrumbs__ellipsisSeparator__lIHBW"};